import FinnWidget from '@eiendomsprofil/finn-widget-web';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import '@eiendomsprofil/finn-widget-web/dist/style.css';
import { useConfig } from 'shared/config/ConfigContext';

import { ErrorBoundary } from 'shared/util/ErrorBoundary';

import styles from './AreaProfile.module.css';

type AreaProfileProps = {
    adId: number;
};

export const AreaProfile = ({ adId }: AreaProfileProps) => {
    const [isClient, setIsClient] = useState(false);
    const { apiExternalUrl } = useConfig();

    useEffect(() => setIsClient(true), []);

    const endpoint = `${apiExternalUrl}/area-profile?id=${adId}`;

    return (
        <div className={cn(styles.areaProfile, 'mx-0 nabolag-widget')} data-testid="nabolag-widget">
            {isClient && (
                <ErrorBoundary>
                    <FinnWidget
                        endpoint={endpoint}
                        config={{
                            resizeThrottleMs: 150,
                            scrollThrottleMs: 66,
                        }}
                    />
                </ErrorBoundary>
            )}
        </div>
    );
};
